import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LINK_TYPES } from 'MeetingsBase/constants/enums';
import { getBookInfo, getHasAbsoluteZeroAvailability, getIsUngatedForRotationsRoundRobin, getRotationsRoundRobinProfile
// @ts-expect-error untyped import
} from 'MeetingsLib/selectors/BookInfoSelectors';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
import Big from 'UIComponents/elements/Big';
import H4 from 'UIComponents/elements/headings/H4';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ZeroState(props) {
  const bookInfo = useSelector(getBookInfo);
  const hasAbsoluteZeroAvailability = useSelector(getHasAbsoluteZeroAvailability);
  const isUngatedForRotationsRoundRobin = useSelector(getIsUngatedForRotationsRoundRobin);
  const rotationsRoundRobinProfile = useSelector(getRotationsRoundRobinProfile);
  const alternativeProfile = bookInfo.get('linkType') === LINK_TYPES.get('roundRobin') && isUngatedForRotationsRoundRobin ? rotationsRoundRobinProfile : null;
  const {
    linkUse,
    profile,
    TimePickerMarker
  } = props;
  const email = alternativeProfile ? alternativeProfile.email : profile.email;
  const renderZeroStateText = () => {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "prebook.timeOptions.zeroState_jsx",
      options: {
        href: `mailto:${email}`,
        external: true,
        use: linkUse,
        email
      },
      elements: {
        Link: UILink
      }
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center",
    children: [/*#__PURE__*/_jsx(H4, {
      role: "alert",
      tabIndex: 1,
      "aria-level": 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasAbsoluteZeroAvailability ? 'prebook.timeOptions.sorryEmptyAvailability' : 'prebook.timeOptions.sorry',
        options: {
          fullName: getLongDisplayName(alternativeProfile || profile)
        }
      })
    }), /*#__PURE__*/_jsx(Big, {
      children: renderZeroStateText()
    }), /*#__PURE__*/_jsx(TimePickerMarker, {})]
  });
}